import styled from "styled-components";

export default styled.div`
  display: flex;
  position: relative;
  top: 0;
  z-index: 1;
  padding: 0.5rem 0.75rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  width: 100%;

  .left-section {
    display: flex;
  }

  .right-section {
    display: flex;
  }
`;
